/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './homepage.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/flex-layout/flexbox/api/layout';
import * as i3 from '@angular/flex-layout/media-query/media-monitor';
import * as i4 from '@angular/flex-layout/flexbox/api/class';
import * as i5 from '../homescreen/homescreen.component.ngfactory';
import * as i6 from '../../../../app/agatextscreens/admin/user.service';
import * as i7 from '@angular/http';
import * as i8 from '../../../../app/app.constants';
import * as i9 from '../../../../app/shared/services/authentication.service';
import * as i10 from '../../../../app/agatextscreens/homescreen/homescreen.component';
import * as i11 from '@angular/router';
import * as i12 from '@covalent/core/dialogs/services/dialog.service';
import * as i13 from '../../../../app/agatextscreens/homepage/homepage.component';
const styles_HomepageComponent:any[] = [i0.styles];
export const RenderType_HomepageComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_HomepageComponent,data:{}});
export function View_HomepageComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'div',[['fxLayout',
      'column']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i2.LayoutDirective,[i3.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n    \n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'div',
          [['class','boxed-content-wrapper']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(933888,(null as any),0,i4.ClassDirective,
          [i3.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'app-homescreen',
          ([] as any[]),(null as any),(null as any),(null as any),i5.View_HomescreenComponent_0,
          i5.RenderType_HomescreenComponent)),i1.ɵprd(512,(null as any),i6.UserService,
          i6.UserService,[i7.Http,i8.Configuration,i9.AuthenticationService]),i1.ɵdid(114688,
          (null as any),0,i10.HomescreenComponent,[i9.AuthenticationService,i6.UserService,
              i11.Router,i12.TdDialogService],(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        const currVal_0:any = 'column';
        _ck(_v,1,0,currVal_0);
        const currVal_1:any = 'boxed-content-wrapper';
        _ck(_v,4,0,currVal_1);
        _ck(_v,8,0);
      },(null as any));
}
export function View_HomepageComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-homepage',
      ([] as any[]),(null as any),(null as any),(null as any),View_HomepageComponent_0,
      RenderType_HomepageComponent)),i1.ɵdid(114688,(null as any),0,i13.HomepageComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const HomepageComponentNgFactory:i1.ComponentFactory<i13.HomepageComponent> = i1.ɵccf('app-homepage',
    i13.HomepageComponent,View_HomepageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL2hvbWVwYWdlL2hvbWVwYWdlLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL3NyYy9hcHAvYWdhdGV4dHNjcmVlbnMvaG9tZXBhZ2UvaG9tZXBhZ2UuY29tcG9uZW50LnRzIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL2hvbWVwYWdlL2hvbWVwYWdlLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL2hvbWVwYWdlL2hvbWVwYWdlLmNvbXBvbmVudC50cy5Ib21lcGFnZUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgZnhMYXlvdXQ9XCJjb2x1bW5cIj5cclxuICAgIFxyXG4gICAgPGRpdiBjbGFzcz1cImJveGVkLWNvbnRlbnQtd3JhcHBlclwiPlxyXG4gICAgICAgIDxhcHAtaG9tZXNjcmVlbj48L2FwcC1ob21lc2NyZWVuPlxyXG4gICAgPC9kaXY+XHJcbjwvZGl2PiIsIjxhcHAtaG9tZXBhZ2U+PC9hcHAtaG9tZXBhZ2U+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTthQUFBO3NCQUFBLHVDQUF1QjtVQUFBLG1CQUVuQjtVQUFBO1VBQUEscUNBQUE7VUFBQTswQkFBQSw2Q0FBbUM7VUFBQSxpQkFDL0I7VUFBQTsyQ0FBQTt5QkFBQSw0REFBQTtVQUFBOzRDQUFBLCtCQUFpQztpQkFBQSw0QkFDL0I7O1FBSkw7UUFBTCxXQUFLLFNBQUw7UUFFUztRQUFMLFdBQUssU0FBTDtRQUNJOzs7O29CQ0hSO01BQUE7a0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/homepage/homepage.component.ngfactory.ts